module.exports = __webpack_public_path__ + "img/bug-window.5be3707b.svg";